import {tns} from "../../../node_modules/tiny-slider/src/tiny-slider";
window.tns = tns;

import '../components/vendors/owlcarousel/init';
import '../components/vendors/fancybox/fancybox.js';
import '../components/vendors/prism/prism.js';
import '../components/base/base.js';
// import '../components/sidebar/sidebar.js';
// import '../components/event/event.js';
// import '../components/special/special.js';
import '../components/general/general.js';
import '../components/footer/footer.js';
import '../components/pages/home/home.js';
import '../components/single-event/single-event.js';
import '../components/single-video/single-video.js';
// import '../components/pages/lektoriy/lektoriy.js';
import '../components/fpga-landing/fpga-landing.js';
import '../components/pages/osobyi-put/osobyi-put-yadro.js';
import '../components/pages/readers-authors/readers-authors.js';
import '../components/pages/bookshelf/bookshelf.js';
import '../components/single-guide/single-guide.js';
import '../components/pages/404/404.js';

//Engineer Letters
import "../components/pages/engineering-letters/engineering-letters";

// Closed school of synthesis
import "../components/pages/school-landing/closed-synthesis-school";

// Yandex Metrika
import "../components/common/yandexMetrika";
